<template>
  <mp-error v-if="isError === true"></mp-error>
  <div v-else class="game-container" :style="getCustomStyle(startGameConfig)">
    <div id="mainImage" class="main-image-container" :style="getImageStyle(imageData)"></div>
    <div id="game-container">
      <div id="cjsTxts" class="main-txt-container"></div>
      <canvas id="gameCanvas"></canvas>
    </div>
    <div v-for="item in getVueComponents()" :key="`${item}`">
      <component
        :is="componentEngine(`${item}`)"
        :start-game-config="gameConfig(`${item}`)"
        :ref="'check' + `${item}`"
      ></component>
    </div>
    <mb-audio-in-game
      :key="data.top + data.left + 'audio' + index"
      v-for="(data, index) in startGameConfig.mbAudioItemData"
      :item-data="data"
      :id="data.id"
    ></mb-audio-in-game>
  </div>
</template>

<script>
/**
 *      MOTTO DNIA: Niech wam wystarczy wierzyć, że tak jest,
 *                  a nie dociekać, dlaczego jest
 */

window.ontouchstart = null;
import _ from 'lodash';
import createjs from 'createjs-collection';
import defaultMixins from '../../mixins/defaultMixin';
import createjsMixin from '../../mixins/createjsMixin';
import * as fJS from '../../mixins/cjsRoot/fJS';
import { cjsStage } from '../../mixins/cjsStage';

import mpError from '../MpError/MpError';
import TrInputOnBackground from '../InputOnBackground/TrInputOnBackground';
import mbAudioInGame from '../../../MbAudioModal/MbAudioInGame';

export default {
  name: 'mp-createjs',
  mixins: [defaultMixins, createjsMixin],
  components: { mpError, TrInputOnBackground, mbAudioInGame },
  props: {
    startGameConfig: {
      type: Object,
      default: function() {
        return {};
      },
    },
  },
  data() {
    return {
      /** @param {object} obiekt zawierający dane tła kanwy */
      imageData: null,
      /** @param {cjsStage} obiekt klasy cjsStage */
      cjsStage: null,
      isError: false,
    };
  },
  beforeMount() {
    this.prototypeArray();

    this.imageData = this.startGameConfig.mainImage;
  },
  mounted() {
    try {
      //    cjsStage.prototype.runLoad(stage);
      this.cjsStage = new cjsStage(this.startGameConfig, this);
      if (this.cjsStage != null) {
        this.cjsStage.resetCheckStatus = this.resetCheckStatus;
        var self = this;
        Promise.all(this.cjsStage._fonts)
          .catch((err) => {
            console.log(err);
          })
          .finally(() => {
            self.cjsStage.initGame();
            self.cjsStage.stage.on('mousedown', self.stageMouseDown);

            self.cjsStage.runFunctionEngine('afterLoadSamples');
            self.cjsStage.runFunctionEngine('defineKeys');
            self.runPromises();
          });
      }
    } catch (e) {
      document.getElementById('mainImage').style.display = 'none';
      document.getElementById('cjsTxts').style.display = 'none';
      this.isError = true;

      if (this.cjsStage != null) this.cjsStage.beforeDestroy();
      delete this.cjsStage;

      console.log(e);
      console.log('GAME F*** SHUTDOWN\nand have a nice day!');
    }
  },
  methods: {
    giveMeImagePlease(p) {
      let path = require('path');
      let imgPath = p;
      imgPath = imgPath.replace('static/', '');
      imgPath = path.normalize(imgPath);
      return imgPath;
    },
    objectImageExist(item) {
      return _.isObject(item) && !_.isNil(item.imagePath);
    },

    runPromises() {
      let self = this;
      Promise.all(this.cjsStage.promises)
        .then((resp) => {
          for (let i = 0; i < resp.length; i++) {
            if (resp[i]._container.cacheId !== 0) resp[i]._container.uncache();
            let p = { x1: false, x2: false, y1: false, y2: false };
            self.cjsStage.getMeasure(p, resp[i]._container);
            resp[i]._container.cache(p.x1, p.y1, p.x2 - p.x1, p.y2 - p.y1);
            resp[i]._container.cacheMeasure = _.cloneDeep(p);
          }
        })
        .then(() => {
          self.cjsStage.update();
          self.cjsStage.runFunctionEngine('afterPromises');
        })
        .catch((err) => {
          document.getElementById('mainImage').style.display = 'none';
          document.getElementById('cjsTxts').style.display = 'none';
          self.isError = true;

          if (self.cjsStage != null) self.cjsStage.beforeDestroy();
          delete self.cjsStage;

          console.log(err);
          console.log('GAME F*** SHUTDOWN\nand have a nice day!');
        });
    },

    getImageStyle(imageData) {
      if (_.isObject(imageData) && imageData.imagePath) {
        if (!imageData.pos) {
          imageData = Object.assign({}, imageData, {
            pos: {
              x: 0,
              y: 0,
            },
          });
        }
        if (!imageData.height) {
          imageData = Object.assign({}, imageData, {
            height: 1080,
          });
        }
        if (!imageData.width) {
          imageData = Object.assign({}, imageData, {
            width: 1920,
          });
        }
      } else {
        return 'display : none;';
      }
      let tempPath = imageData.imagePath.replace('static/games/', `${this.$store.getters.multibookType}/games/`);
      let path = require('path');
      let imagePath;
      if (process.platform === 'win32') {
        // imagePath = path.win32.normalize(tempPath);
        imagePath = path.win32
          .normalize(tempPath)
          .split('\\')
          .join('/');
      } else {
        imagePath = path.normalize(tempPath);
      }
      let image = require(`__staticDir/${imagePath}`);
      return _.merge({ position: 'absolute', left: '0' }, this.getCustomStyle(imageData), {
        'background-image': `url(${image})`,
        top: fJS.isNumeric(imageData.pos.y)
          ? imageData.pos.y + 'px'
          : fJS.isNumeric(imageData.offsetVertical)
          ? imageData.offsetVertical
          : 0,
        left: fJS.isNumeric(imageData.pos.x)
          ? imageData.pos.x + 'px'
          : fJS.isNumeric(imageData.offsetHorizontal)
          ? imageData.offsetHorizontal
          : 0,
        width: fJS.isNumeric(imageData.width) ? imageData.width + 'px' : '100%',
        height: fJS.isNumeric(imageData.height) ? imageData.height + 'px' : '100%',
      });
    },
    getCustomStyle(item) {
      let customStyle = {};
      if (item && item.cssStyle) {
        if (_.isObject(item.cssStyle)) {
          customStyle = _.mapKeys(item.cssStyle, function(value, key) {
            return _.toString(key);
          });
        }
      }
      return customStyle;
    },

    stageMouseDown(e) {
      this.resetCheckStatus();
    },

    checkGameAction() {
      this.resetCheckStatus();

      let correct = true;
      for (const key in this.$refs) {
        correct = this.$refs[key][0].checkGameAction() !== true ? false : correct;
      }

      return this.cjsStage.checkGameAction() && correct;
    },

    resetGameAction() {
      this.resetCheckStatus();
      this.cjsStage.resetGameAction();
      this.cjsStage.runFunctionEngine('afterLoadSamples');
      this.cjsStage.runFunctionEngine('defineKeys');
      this.runPromises();
      this.cjsStage.stage.on('mousedown', this.stageMouseDown);
    },

    getVueComponents() {
      console.log(this.startGameConfig);
      if (typeof this.startGameConfig.vue !== 'object' || this.startGameConfig.vue === null) {
        return [];
      }
      return Object.keys(this.startGameConfig.vue);
    },

    componentEngine(name) {
      return `${name}`;
    },

    gameConfig(name) {
      if (
        typeof this.startGameConfig.vue !== 'object' ||
        this.startGameConfig.vue === null ||
        typeof this.startGameConfig.vue[name] !== 'object' ||
        this.startGameConfig.vue[name] === null
      )
        throw 'Brak konfiguracji dla komponentu: ' + name;

      return _.cloneDeep(this.startGameConfig.vue[name]);
    },
  },
  beforeDestroy() {
    if (this.cjsStage != null) this.cjsStage.beforeDestroy();
  },
};
</script>
<style lang="scss"></style>
<style lang="scss" scoped>
.game-container {
  display: flex;
  padding: 160px 50px 100px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100% !important;
  height: 100% !important;
  position: absolute;
  position: inherit;
}
.game-input-on-background-wrapper {
  display: contents;
}

#game-container {
  width: 100%;
  height: 100%;
  z-index: 1;
  position: relative;
}

.main-image-container,
.main-txt-container {
  display: block;
  width: 100%;
  height: 100%;

  background-size: contain;
  background-repeat: no-repeat;
}

.main-txt-container {
  top: 0;
  left: 0;
  z-index: 0;
  position: static;

  border-style: solid;
  display: none;
}

canvas {
  z-index: 10;
  position: absolute;
  top: 0;
  left: 0;
}
</style>
